import { Component, Input } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AnalyticsService } from 'src/app/services/administration/analytics.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-logi-dashboards-view-model',
  templateUrl: './logi-dashboards-view-model.component.html',
  styleUrls: ['./logi-dashboards-view-model.component.scss']
})
export class LogiDashboardsViewModelComponent {


  DashboardViewForm: UntypedFormGroup;
  @Input() public Content: any;
  DashboardID: string;
  ProgramExt: any;

  constructor(
    public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    public analyticsService: AnalyticsService,
    public commonservice: CommonService,
  ) {
  }

  ngOnInit() {
    //this.IsAutoCodeConfigured();
    this.DashboardID = this.Content.content.id;
    this.GetMasterData();
    this.DashboardViewForm = new UntypedFormGroup(
      {
        ID: new UntypedFormControl(""),
        DASHBOARD_NAME: new UntypedFormControl("", [Validators.required, Validators.maxLength(25)]),
        DISPLAY_NAME: new UntypedFormControl("", [Validators.required, Validators.maxLength(100)]),
        DESCRIPTION: new UntypedFormControl(""),
        RECORD_STATE: new UntypedFormControl(""),
        
      });
    this.DashboardViewForm.controls["DASHBOARD_NAME"].disable();
    this.DashboardViewForm.controls["RECORD_STATE"].disable();
  }

  GetMasterData() {
    this.analyticsService.getDashboardsDetailsID(this.DashboardID).subscribe(data => {
      this.DashboardViewForm.patchValue(data);
      this.ProgramExt=data.ProgramExt;
      if (data.RecordState == 1)
        this.DashboardViewForm.controls['RECORD_STATE'].setValue(true);
    })
  }

  Edit() {
    let Name = this.DashboardViewForm.controls['DASHBOARD_NAME'].value;
    this.analyticsService.UpdateAnalyticsDashboardDetails(this.DashboardViewForm.getRawValue()).subscribe(result => {
      if (result != null && result != undefined) {
         
        if (result.Status==0) {
          this.commonservice.SuccessBanner('Dashboard '+ Name+' updated successfully.');
          this.closePopup();
        } else {
          this.commonservice.ValidationBanner(result.Message);
        }
      }
    })
  }

  closePopup() {
    this.modalRef.close();
  }

}
